window.ContentContainerWithLabelledImages = (uniqueId) => {
    return {
        lineHeight1 : 1,
        lineHeight2 : 1,
        roundedImage : null,
        bottomImage : null,
        line1startingPoint: null,
        line2startingPoint: null,
        line1 : null, 
        line2 : null, 

        init() {
            this.roundedImage = document.getElementById(`rounded-image${ uniqueId }`);
            this.bottomImage =  document.getElementById(`bottom-image${ uniqueId }`);
            this.line1startingPoint = document.getElementById(`line-1-starting-point${ uniqueId }`);
            this.line2startingPoint = document.getElementById(`line-2-starting-point${ uniqueId }`);
            this.line1 = document.getElementById(`line-1${ uniqueId }`);
            this.line2 = document.getElementById(`line-2${ uniqueId }`);
            this.calcLineHeights();

        },

        calcLineHeights() {
            if (this.roundedImage && this.line1startingPoint && this.line1) {
                
                this.lineHeight1 = (this.line1startingPoint.offsetTop - this.roundedImage.offsetTop) - (this.roundedImage.offsetHeight * 0.75);

                if (this.lineHeight1 < 0) {
                    this.lineHeight1 = 0;
                }
            } else {
                this.lineHeight1 = 0;
            }

            if (this.bottomImage && this.line2startingPoint && this.line2) {
                
                const line2StartingPointBottom = this.line2startingPoint.offsetTop + this.line2startingPoint.offsetHeight;
                this.lineHeight2 = (this.bottomImage.offsetTop - line2StartingPointBottom) - (this.bottomImage.offsetHeight * 0.8);
                
                if (this.lineHeight2 < 0) {
                    this.lineHeight2 = 0;
                }
            } else {
                this.lineHeight2 = 0;
            }
        }
    }
}